import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import Logo from "../../assets/png/supermarket-logo.png";
import { themeHome } from "../../utils/styling";

const Holder = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid ${(props) => props.theme.colors.text};
  height: var(--footerHeight);
  background-color: ${themeHome.colors.primary};
`;

const LinksHolder = styled.div`
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  a {
    color: ${(props) => props.theme.colors.text};

    &:hover,
    &[aria-current="page"] {
      text-decoration: underline;
    }
  }
`;

const Footer = () => {
  return (
    <Holder>
      <LinksHolder>
        <a
          href="https://www.linkedin.com/company/86967968/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/supermarket.london/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        <a
          href="mailto:info@supermarket.london"
          target="_blank"
          rel="noopener noreferrer"
        >
          info@supermarket.london
        </a>
      </LinksHolder>
    </Holder>
  );
};

export default Footer;
